import { Text } from '@chakra-ui/react';

import { classNames } from '@/utils/classNames';

/**
 * @typedef {Object} ChakraTextProps
 * @property {import('react').ReactNode} children
 * @param {import('@chakra-ui/react').TextProps & ChakraTextProps} props
 * @returns
 */
export default function ChakraText({ children, ...rest }) {
    return (
        <Text {...rest} className={classNames(rest.className)}>
            {children}
        </Text>
    );
}
